export const JobActionTypes = {
  LOADING_CREATE_JOB: 'LOADING_CREATE_JOB',
  LOADING_JOB: 'LOADING_JOB',
  LOADING_SINGLE_JOB: 'LOADING_SINGLE_JOB',
  UPDATING_JOB: 'UPDATING_JOB',
  LOAD_JOB_START: 'LOAD_JOB_START',
  LOAD_JOB_SUCCESS: 'LOAD_JOB_SUCCESS',
  LOAD_JOB_FAILURE: 'LOAD_JOB_FAILURE',
  LOAD_LIST_JOB_START: 'LOAD_LIST_JOB_START',
  LOAD_LIST_JOB_SUCCESS: 'LOAD_LIST_JOB_SUCCESS',
  LOAD_LIST_JOB_FAILURE: 'LOAD_LIST_JOB_FAILURE',
  UPDATE_JOB_IN_LIST: 'UPDATE_JOB_IN_LIST',
  CREATE_JOB_START: 'CREATE_JOB_START',
  CREATE_JOB_SUCCESS: 'CREATE_JOB_SUCCESS',
  CREATE_JOB_FAILURE: 'CREATE_JOB_FAILURE',
  UPDATE_JOB_START: 'UPDATE_JOB_START',
  UPDATE_JOB_SUCCESS: 'UPDATE_JOB_SUCCESS',
  UPDATE_JOB_FAILURE: 'UPDATE_JOB_FAILURE',
  APPLY_JOB_START: 'APPLY_JOB_START',
  APPLY_JOB_SUCCESS: 'APPLY_JOB_SUCCESS',
  APPLY_JOB_FAILURE: 'APPLY_JOB_FAILURE',
  LOADING_APPLY_JOB: 'LOADING_APPLY_JOB',
  SAVE_CV_JOB_START: 'SAVE_CV_JOB_START',
};
